import React, { useMemo } from 'react';
import { isNaN, isFinite } from 'lodash';
import SmallDonutChartDetail from 'spw-components/charts/small-donut-chart-detail';
import { hasCustomSubcategory } from 'spw-redux/modules/project-space-type-categories/utils';
import {
  IProjectColors,
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import { PlainWorksheet } from '../../../../models/Worksheet';
import { useCategoryData } from './hooks/use-category-data';

interface IProps {
  style?: { [key: string]: number | string };
  chartStyle?: { [key: string]: number | string };
  title: string;
  subtitle: string;
  projectSpaceTypeCategory: IProjectSpaceTypeCategory;
  projectColors: IProjectColors;
  worksheet: PlainWorksheet;
  isTotalProgramScenario: boolean;
  individualWorkspacesCategory?: IProjectSpaceTypeCategory;
}

const SeatTypeMixCategoryChart: React.FunctionComponent<IProps> = ({
  style,
  chartStyle,
  title,
  subtitle,
  projectSpaceTypeCategory,
  projectColors,
  worksheet,
  isTotalProgramScenario,
  individualWorkspacesCategory,
}) => {
  const { colors, titles, getData } = useCategoryData(
    projectSpaceTypeCategory,
    projectColors
  );
  const worksheetWorkSeats = worksheet.scenario.workSeats;

  const subcategoriesData = useMemo(() => {
    return projectSpaceTypeCategory.subcategories
      ?.filter((sub) => sub.includeInTotalWorkSeats)
      ?.map((subcategory: IProjectSpaceTypeSubcategory, index: number) => {
        const defaultSubcategory =
          subcategory.defaultSpaceTypeCategory.category;
        const subcategorySeats =
          worksheet.subcategoriesTotals[defaultSubcategory]?.seats || 0;
        const subcategorySeatsPercent = subcategorySeats / worksheetWorkSeats;
        let subcategorySeatsPercentValue = 0;

        if (
          !isNaN(subcategorySeatsPercent) &&
          isFinite(subcategorySeatsPercent)
        ) {
          subcategorySeatsPercentValue = subcategorySeatsPercent;
        }

        return {
          quantity: subcategorySeats,
          percent: subcategorySeatsPercentValue,
          name: titles[index],
          color: colors[index],
        };
      });
  }, [
    projectSpaceTypeCategory.subcategories,
    worksheet.subcategoriesTotals,
    titles,
    colors,
    worksheetWorkSeats,
  ]);

  const data = getData(subcategoriesData);

  return (
    <div style={style}>
      <SmallDonutChartDetail
        style={chartStyle}
        title={title}
        subtitle={subtitle}
        total={worksheetWorkSeats}
        spacesData={subcategoriesData}
        isTotalProgramScenario={isTotalProgramScenario}
        data={data}
        colors={colors}
        spaceTypeNamesStyle={{
          paddingTop:
            hasCustomSubcategory(individualWorkspacesCategory) &&
            subcategoriesData.length === 2
              ? 26
              : 0,
        }}
        testingPrefix="programming_ps_seat_type_mix_cat_chart"
      />
    </div>
  );
};

export default SeatTypeMixCategoryChart;
